import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TruncatedCopyableTextProps {
  text: string;
  maxWidth?: string;
  children?: React.ReactNode;
}

export function TruncatedCopyableText({ text, maxWidth = "120px", children }: TruncatedCopyableTextProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex items-center gap-1 group">
      <div 
        className="truncate" 
        style={{ maxWidth }}
        title={text}
      >
        {children || text}
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-5 w-5 p-0 opacity-0 group-hover:opacity-100 transition-opacity"
        onClick={handleCopy}
      >
        {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      </Button>
    </div>
  );
}